/**
 * The words of the HR screens review of 2026-10-07 still open on 2026-10-10 (medium and low, part D:
 * recruitment, onboarding and offboarding, performance and training, custody, benefits, discipline,
 * grievances and rewards, self-service). Kept beside the catalogue, as the other HR rounds' words
 * are, and spread into it.
 */
export const HR_REVIEW_D_EN = {
    // human-resources-q7kmpsbx: a vacancy's candidates still in play, and a filled one that still has some.
    "unit.candidates.zero": "{n} candidates",
    "unit.candidates.one": "{n} candidate",
    "unit.candidates.two": "{n} candidates",
    "unit.candidates.few": "{n} candidates",
    "unit.candidates.many": "{n} candidates",
    "unit.candidates.other": "{n} candidates",
    // human-resources-q7kne95p: the case a clearance line belongs to, as it stands; the ways a case leaves its path.
    "value.required.true": "Required",
    "value.required.false": "Optional",
};
export const HR_REVIEW_D_AR = {
    "unit.candidates.zero": "{n} مرشّح",
    "unit.candidates.one": "مرشّح واحد",
    "unit.candidates.two": "مرشّحان",
    "unit.candidates.few": "{n} مرشّحين",
    "unit.candidates.many": "{n} مرشّحًا",
    "unit.candidates.other": "{n} مرشّح",
    "value.required.true": "إلزامي",
    "value.required.false": "اختياري",
};
//# sourceMappingURL=i18n-hr-review-d.js.map